export const rgbaToHex = (rgba: string) => {
  const result = rgba.match(/\d+(?:\.\d+)?/g);
  if (!result) return rgba;
  const r = parseInt(result[0]);
  const g = parseInt(result[1]);
  const b = parseInt(result[2]);
  // Opacity (alpha) may be undefined or a float between 0 and 1
  const a = result[3] !== undefined ? Math.round(parseFloat(result[3]) * 255) : undefined;
  const hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  if (a !== undefined && !isNaN(a)) {
    return hex + a.toString(16).padStart(2, '0');
  }
  return hex;
};
